import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const get = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('estimaciones'), { params });
};

const getEstimacionesSedesPorPartidas = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('estimaciones/todas-sedes-por-partidas'), { params });
};

const getEstimacionesPorPartidaYSede = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('estimaciones/gestion-todas'), { params });
};

const getPorPartidas = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('estimaciones/por-partidas'), { params });
};

const store = async (data) => {
  return await axiosIns.post(obtenerUrl('estimaciones'), data);
};

const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`estimaciones/${id}`), data);
};

const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`estimaciones/${id}`));
};

const revisar = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`estimaciones/${id}/revisar`), data);
};

const aprobar = async (id, { params }) => {
  return await axiosIns.get(obtenerUrl(`estimaciones/aprobar/${id}`), { params });
};

const findGestion = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('estimaciones/gestion'), { params });
};

const findGestionEstado = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('estimaciones/gestion'), { params });
};

const show = async (id, { params }) => {
  return await axiosIns.get(obtenerUrl(`estimaciones/${id}/gestion`), { params });
};

const findGestionExcel = async (sede_id) => {
  return await axiosIns.get(obtenerUrl(`estimaciones-excel/gestion?sede_id=${sede_id}`), { responseType: 'blob' });
};

const findReporteExcel = async (sede_id) => {
  return await axiosIns.get(obtenerUrl(`estimaciones-excel/reporte?sede_id=${sede_id}`), { responseType: 'blob' });
};

const getEstimacionesPorSedes = async ({ params }) => {
  return await axiosIns.get(obtenerUrl('estimaciones/sedes'), { params });
};

export default {
  get,
  store,
  update,
  destroy,
  revisar,
  aprobar,
  findGestion,
  show,
  findGestionExcel,
  findReporteExcel,
  getPorPartidas,
  getEstimacionesSedesPorPartidas,
  getEstimacionesPorPartidaYSede,
  getEstimacionesPorSedes,
  findGestionEstado,
};
